import { render, staticRenderFns } from "./AllowanceDetailReportTableRow.vue?vue&type=template&id=1a9a45c4"
import script from "./AllowanceDetailReportTableRow.vue?vue&type=script&lang=js"
export * from "./AllowanceDetailReportTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports